import { ForgotPasswordActionTypes } from '../../actions/forgot-password/forgot-password.actions';
import { AppState } from 'src/app/app.state';
import { ApiResponseSimple } from 'src/app/shared/models/api-response-simple/ApiResponseSimple';

export interface ForgotPasswordState {
  error?: ApiResponseSimple;
  captcha: boolean;
  linkLoading: boolean;
  linkLoaded: boolean;
  resetLoading: boolean;
  resetLoaded: boolean;
}

const initialState: ForgotPasswordState = {
  error: null,
  captcha: null,
  linkLoading: null,
  linkLoaded: null,
  resetLoading: null,
  resetLoaded: null
};

export function forgotPasswordReducer(state: ForgotPasswordState = initialState, action: any): ForgotPasswordState {
  switch (action.type) {
    case ForgotPasswordActionTypes.CAPTCHA:
      return {
        ...state,
        error: null,
        captcha: true,
        linkLoading: false,
        linkLoaded: false,
        resetLoading: false,
        resetLoaded: false
      };

    case ForgotPasswordActionTypes.REQUEST_LINK:
      return {
        ...state,
        error: null,
        captcha: false,
        linkLoading: true,
        linkLoaded: false,
        resetLoading: false,
        resetLoaded: false
      };

    case ForgotPasswordActionTypes.REQUEST_LINK_SUCCESS:
      return {
        ...state,
        error: null,
        captcha: false,
        linkLoading: false,
        linkLoaded: true,
        resetLoading: false,
        resetLoaded: false
      };

    case ForgotPasswordActionTypes.REQUEST_LINK_ERROR:
      return {
        ...state,
        error: action.error,
        captcha: false,
        linkLoading: false,
        linkLoaded: false,
        resetLoading: false,
        resetLoaded: false
      };

    case ForgotPasswordActionTypes.REQUEST_RESET:
      return {
        ...state,
        error: null,
        captcha: false,
        linkLoading: false,
        linkLoaded: false,
        resetLoading: true,
        resetLoaded: false
      };

    case ForgotPasswordActionTypes.REQUEST_RESET_SUCCESS:
      return {
        ...state,
        error: null,
        captcha: false,
        linkLoading: false,
        linkLoaded: false,
        resetLoading: false,
        resetLoaded: true
      };

    case ForgotPasswordActionTypes.REQUEST_RESET_ERROR:
      return {
        ...state,
        error: action.error,
        captcha: false,
        linkLoading: false,
        linkLoaded: false,
        resetLoading: false,
        resetLoaded: false
      };

    default:
      return state;
  }
}

export const getForgotPasswordState = (state: AppState) => state.forgotPassword;
export const getForgotPasswordCaptcha = (state: ForgotPasswordState) => state.captcha;
export const getForgotPasswordRequestLinkLoading = (state: ForgotPasswordState) => state.linkLoading;
export const getForgotPasswordRequestLinkSuccess = (state: ForgotPasswordState) => state.linkLoaded;
export const getForgotPasswordRequestLinkError = (state: ForgotPasswordState) => state.error;
export const getForgotPasswordRequestResetLoading = (state: ForgotPasswordState) => state.resetLoading;
export const getForgotPasswordRequestResetSuccess = (state: ForgotPasswordState) => state.resetLoaded;
export const getForgotPasswordRequestResetError = (state: ForgotPasswordState) => state.error;
